import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useDispatch, useSelector } from 'react-redux';
import { zoomLevels } from '../../GanttVisualization/constants';
import company from '../builder/ScheduleOfSchedulesBuilder/columns/company';
import { destroyGantt, openForm } from '../utils';

const ganttType = 'scheduleOfSchedules';
const ganttName = 'ganttScheduleOfSchedule';

const GANTT_WIDTH_WITH_COMPANY_COLUMN = 870;
const GANTT_WIDTH_WITHOUT_COMPANY_COLUMN = 770;

export const useMountGanttAfterFetchProjects = ({
  scheduleFactory,
  setFormDeleteVisible,
  setFormProjectVisible,
  onClickProject,
  setZoomLevel,
  zoomLevel,
  filteredSchedules,
  filterCompany,
  ganttRef,
  isLoading,
  processedProjects,
  permissions,
  filterText,
  schedules,
  currentColumnSort,
  isDesc,
  applySorting
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const projectState = useSelector(({ projectState }) => projectState);
  useEffect(() => {
    if (!filteredSchedules.length || !ganttRef.current || isLoading) {
      destroyGantt(ganttName);
      return;
    }

    const analytics = {
      search_text: filterText,
      results_count: filteredSchedules.length
    };

    const handleDelete = openForm({
      handler: setFormDeleteVisible,
      handlerName: 'setFormDeleteVisible',
      permissions,
      projectState,
      dispatch
    });

    const handleEdit = openForm({
      handler: setFormProjectVisible,
      handlerName: 'setFormProjectVisible',
      permissions,
      projectState,
      dispatch
    });

    const ganttOptions = {
      t,
      handleDelete,
      handleEdit,
      processedProjects,
      onClickProject,
      analytics,
      setZoomLevel
    };

    const gantt =
      window[ganttName] || scheduleFactory.create(ganttType, ganttOptions);

    if (!window[ganttName]) {
      window[ganttName] = gantt;
      gantt.init(ganttRef.current);
    }

    if (filterCompany) {
      const columns = gantt.config.columns.filter(
        ({ name }) => name !== 'company'
      );
      gantt.config.columns = [...columns, company(gantt, { t })];
      gantt.$layout.$cells[0].$config.width = GANTT_WIDTH_WITH_COMPANY_COLUMN;
    } else {
      gantt.config.columns = gantt.config.columns.filter(
        (el) => el.name !== 'company'
      );
      gantt.$layout.$cells[0].$config.width =
        GANTT_WIDTH_WITHOUT_COMPANY_COLUMN;
    }

    const visibleProjects = filteredSchedules.filter(({ name }) => name).length;

    gantt.setProjectsCount(visibleProjects, schedules.total);
    gantt.changeScaleVisualization(zoomLevels.length - 1 - zoomLevel);
    gantt.clearAll();
    gantt.parse({ data: filteredSchedules });
    applySorting(gantt, currentColumnSort, isDesc);
    gantt.render();
    gantt.createMarker();
  }, [filteredSchedules, processedProjects, isLoading, filterText, zoomLevel]);
};
